import { render, staticRenderFns } from "./LocationLabelScan.vue?vue&type=template&id=80caf634&scoped=true"
import script from "./LocationLabelScan.vue?vue&type=script&lang=js"
export * from "./LocationLabelScan.vue?vue&type=script&lang=js"
import style0 from "./LocationLabelScan.vue?vue&type=style&index=0&id=80caf634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80caf634",
  null
  
)

export default component.exports